var map = {
	"./img/andalucia/teaser_large.jpg": 45753,
	"./img/basque-country/teaser_large.jpg": 92539,
	"./img/berlin/teaser_large.jpg": 9513,
	"./img/copenhagen/teaser_large.jpg": 1525,
	"./img/portugal/teaser_large.jpg": 4348,
	"./img/slovenia/teaser_large.jpg": 43240,
	"./img/turkey/teaser_large.jpg": 57611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42147;